import { InnovyzeRole, SecondaryNavItem } from '@innovyze/stylovyze';
import { TFunc } from '@Translations/types';
import { addRouteNamespace } from '@Utils/actions';
import React from 'react';
import IntegrationsView from '../IntegrationsTab';
import { Subscription } from '@innovyze/shared-utils';

export const integrationTabs = (t: TFunc) =>
	[
		{
			title: t('Integrations'),
			content: <IntegrationsView />,
			cy: 'integration-nav-btn',
			to: addRouteNamespace('integrations'),
			minimumRole: InnovyzeRole.READ_WRITE,
			gatedEntitlements: [
				Subscription.I360AFA,
				Subscription.ASSET_FULL_ACCESS,
			],
		},
	] as (SecondaryNavItem & { to: string })[];
